export const sipEventsMixin = {

    //********************* SUBSCRIBE TO SIP EVENTS ********************************//
    // 'gudhub_sip' pushes ('/ws/emit-to-user', same mechanism as 'gudhub_messenger' -
    // see gh_conversation/components/directMessageChat/mixins/subscriptionMixin.js)
    // are advisory-only (logging/toasts). The actual incoming-call UI is driven
    // exclusively by SIP.js's own delegate.onInvite (see callSessionMixin), since
    // only that carries the live Invitation needed to answer.
    subscribeToSipEvents() {
        gudhub.on('gudhub_sip', { user_id: this.activeUserId }, this.handleSipEvent);
    },

    //********************* UNSUBSCRIBE FROM SIP EVENTS ********************************//
    unsubscribeFromSipEvents() {
        if(this.activeUserId) {
            gudhub.destroy('gudhub_sip', { user_id: this.activeUserId }, this.handleSipEvent);
        }
    },

    //********************* HANDLE SIP EVENT ********************************//
    // * error (null), data (Object) — { event: 'incoming'|'ringing'|'answered'|'ended'|'missed'|'call_recorded', call_id, from, to }
    // 'missed' is pushed to both the caller and the callee (see sip-gudhub-server's
    // callEventHandler.js) with identical from/to - only show the toast to the
    // callee (data.to), the one who actually missed the call, not the one who
    // placed it.
    async handleSipEvent(error, data) {
        if(data.event === 'missed' && this.callState !== 'in_call' && String(data.to) === this.activeUserId) {
            const caller = await gudhub.getUserById(String(data.from));
            const callerName = caller?.fullname || data.from;
            this.toast?.customToast({
                template: `<md-toast><p>Missed call from ${callerName}</p></md-toast>`,
                hideDelay: 5000
            });
        }
    },
};
